import axios from 'axios';

let urls = process.env.videoURL;

//urls = "https://billing-test.services.orcicare.com/"

const get_urls = () => {
    const host = window.location.host.split(":")[0];
    if (host === "provider-web.services.orcicare.com") {
        return "https://video.services.orcicare.com/"
    }
    return `https://video-test.services.orcicare.com/`
};

const url = urls || get_urls();

const instance = axios.create({
    baseURL: url
});

export default instance;